// removed by extract-text-webpack-plugin
module.exports = {"sec":"Dialog__sec__3005mHLD","changebind_box":"Dialog__changebind_box__2W6cp3L9","user_info":"Dialog__user_info__-Dg63HiA","info_tips":"Dialog__info_tips__1okpNGlT","user_img":"Dialog__user_img__15NOtVtj","img_mask":"Dialog__img_mask__31OJUD1a","user_name":"Dialog__user_name__R4s26Qnz","change_arrow":"Dialog__change_arrow__1m6HuxV0","tips":"Dialog__tips__2GZU1F8d","bind_box":"Dialog__bind_box__14tYykx2","bind_tips":"Dialog__bind_tips__1gEvxm-7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Dialog/Dialog.scss
// module id = YyqG
// module chunks = 0